import { cancellablePromise, delay, useCancellablePromises, useSingleAndDoubleClick } from './useSingleAndDoubleClick';

export { cancellablePromise, delay, useCancellablePromises };

export default useSingleAndDoubleClick;
